import type { ReactNode } from 'react'
import React, { createContext, useContext, useState } from 'react'

// Define the shape of the context data
interface TextContextType {
  headerText: string
  setHeaderText: (text: string) => void
}

// Create the context
const TextContext = createContext<TextContextType | undefined>(undefined)

// Define the props for the TextProvider
interface TextProviderProps {
  children: ReactNode // Define children as ReactNode
}

// Provider component
export const TextProvider: React.FC<TextProviderProps> = ({ children }) => {
  const [headerText, setHeaderText] = useState<string>('')

  return <TextContext.Provider value={{ headerText, setHeaderText }}>{children}</TextContext.Provider>
}

// Custom hook to use the Text context
export const useText = () => {
  const context = useContext(TextContext)

  if (!context) {
    throw new Error('useText must be used within a TextProvider')
  }

  return context
}
